module.exports = `${require.publicPath}icon14.28169783.png`;